import { useEffect, useState, MutableRefObject } from 'react';
import { PLACE_HOLDER } from 'src/constants';

interface IProps {
    imgRef: MutableRefObject<null | HTMLImageElement>;
    src: string;
    intersectionObserverOptions?: IntersectionObserverInit;
}

export function useImage({
    imgRef,
    src,
    intersectionObserverOptions = {
        rootMargin: '100px',
    },
}: IProps): [string] {
    const [imgSrc, setImgSrc] = useState(PLACE_HOLDER.IMAGE);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setImgSrc(src);
                    observer.unobserve(entry.target);
                }
            });
        }, intersectionObserverOptions);

        if (imgRef && imgRef.current) {
            observer.observe(imgRef.current);
        }

        return () => {
            if (imgRef && imgRef.current) {
                setImgSrc(PLACE_HOLDER.IMAGE)
                observer.disconnect();
            }
        };
    }, [imgRef, src]);

    return [imgSrc];
}

export default useImage;